import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

function CustomDatePicker({ label, name, value, onChange, onError, disabled = false }) {
  // Ensure valid date value (convert strings to dayjs objects)
  const safeValue = React.useMemo(() => {
    if (!value) return null;

    try {
      const dateValue = dayjs(value);
      return dateValue.isValid() ? dateValue : null;
    } catch (e) {
      console.warn('Invalid date format:', value);
      return null;
    }
  }, [value]);

  // Handle change with validation
  const handleChange = (newValue) => {
    if (onChange) {
      try {
        // Ensure we pass a valid dayjs object or null
        onChange(newValue && dayjs(newValue).isValid() ? newValue : null);
      } catch (e) {
        console.error('Error in date change:', e);
        onChange(null);
      }
    }
  };

  // Handle date picker errors
  const handleError = (reason, value) => {
    if (onError) {
      onError(reason);
    } else if (reason) {
      console.warn('Date validation error:', reason);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={safeValue}
        onChange={handleChange}
        disabled={disabled}
        minDate={dayjs()}
        slotProps={{
          textField: {
            variant: "outlined",
            fullWidth: true,
            name: name,
            error: false,
          },
        }}
        onError={handleError}
      />
    </LocalizationProvider>
  );
}

export default CustomDatePicker;